module.exports = __webpack_public_path__ + "img/5_103.fb1dea5e.png";